import React from "react";

// Components
import Overlay from "shared/components/overlay/Overlay";
import SlidingPanel from "shared/components/sliding-panel/SlidingPanel";
import LeadDetail from "./LeadDetail";

// Styles
import styles from './AddLead.module.scss';

const LeadDetailPanel = ({ isActive=false, lead='', onSaveLead, onClose }) => {
    return (
        <div className={ styles.wrapper }>
            <SlidingPanel className={ styles.panel } isActive={ isActive }>
                { lead && <LeadDetail
                    onClose={ onClose }
                    lead={ lead }
                    onSaveLead={ onSaveLead } />
                }
            </SlidingPanel>

            <Overlay
                className={ styles.overlay }
                isActive={ isActive }
                isContained
                onClick={ onClose } />
        </div>
    )
}

export default LeadDetailPanel;
